import { actions } from './typeHospitalization/actions'
import { getters } from './typeHospitalization/getters'
import { state } from './typeHospitalization/state'
import { mutations } from './typeHospitalization/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
